module.exports = __webpack_public_path__ + "img/嘿哈.9debf027.png";